import { render, staticRenderFns } from "./AppStarButton.vue?vue&type=template&id=1d2555e6&"
import script from "./AppStarButton.vue?vue&type=script&lang=js&"
export * from "./AppStarButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports